import { toast } from 'react-hot-toast';

export const inactiveEmailToast = (): void => {
  toast.error(
    <div className="flex flex-col space-y-2">
      <span>This email address has been marked as inactive and cannot receive emails.</span>
      <span className="text-sm italic">Please contact support to reactivate your email address.</span>
    </div>,
    { duration: 10000 }
  );
};
